
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    flexGrow: 1,
}));

const ServiceItem = (props: { children: React.ReactNode; }): React.ReactNode => {
    return <Grid2 size={{ xs: 6, sm: 6, md: 3, lg: 3 }}>{props.children}</Grid2>;
};

export const Produits = () => { 
    return <Container>
        <Box sx={{ p: 4 }}>
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant='h2' >
                    Les pieux <em>Pieux Protech</em>
                </Typography>
                <Typography>
                    Nos pieux sont fabriqués par des entreprises québécoises avec des matériaux de première qualité et galvanisés intérieur et extérieur. De plus, ils sont entièrement personnalisables! Nous travaillons en collaboration avec <a href="http://www.outils-concept.com/" target="_blank">Outils Concept</a> afin d’assurer la parfaite taille de vos pieux.
                </Typography>
            </Box>
            <Box sx={{ p: 3 }}>
                <Box sx={{ width: '100%' }} component='img' src="/images/pieux_protech_showcase.jpg" />
            </Box>
            <Box>
                <Grid2 container spacing={2}>
                    <ServiceItem>
                        <Card>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Petit pieux
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    1"-7/8 de diamètre avec 8 pouces d’ailette.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Pieux standard
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    2"-3/8 de diamètre avec choix d'ailettes allant de 8" à 12" de diamètre.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Pieux HD
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    3.5" de diamètre avec choix d'ailettes de 12" à 20" de diamètre.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                    <ServiceItem>
                        <Card>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Pieux sur mesure
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Tous nos pieux peuvent être conçus sur mesure selon votre demande.
                                </Typography>
                            </CardContent>
                        </Card>
                    </ServiceItem>
                </Grid2>
            </Box>
        </Box>
    </Container>;
};
